




















import Vue from "vue";

interface Data {
  showTooltip: boolean;
}

interface Methods {
  onInput: (val: string) => void;
}

interface Props {
  autocompleteType: string;
  disabled: boolean;
  error?: string;
  placeholder?: string;
  value: string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "PasswordConfirmationWithTooltip",

  props: {
    autocompleteType: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    value: { type: String, required: true }
  },
  data() {
    return {
      showTooltip: false
    };
  },

  methods: {
    onInput(val: string) {
      this.$emit("input", val);
    }
  }
});
